var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "dropdown-menu" }, [
    _c("li", { staticClass: "header" }, [_vm._v(_vm._s(_vm.infoMessage))]),
    _vm._v(" "),
    _c("li", [
      _c(
        "ul",
        { staticClass: "menu" },
        [
          _vm._l(_vm.unreadTopics, function (unreadTopic) {
            return _c("topbar-unread-topic", {
              key: unreadTopic.id,
              attrs: { "unread-topic": unreadTopic, "auth-id": _vm.authId },
            })
          }),
          _vm._v(" "),
          _vm.unreadTopics.length == 0
            ? _c("li", { staticClass: "text-center" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v(_vm._s(_vm._t("No new messages"))),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "footer" }, [
      _c("a", { attrs: { href: _vm.viewAllRoute } }, [
        _vm._v(_vm._s(_vm._t("View all"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }